module.exports = __webpack_public_path__ + "static/img/industry-leaders.45638d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/industry-leaders.png
// module id = CLCR
// module chunks = 50